<template>
	<div class="search-suggest">
		<b-tabs pills card @input="changeTab">
			<b-tab
				title="Jobs"
				tabindex="1"
				:active="selectedTab == '1' || $route.query.status == 1"
			></b-tab>
			<b-tab title="|" disabled></b-tab>
			<b-tab
				title="Assessments"
				tabindex="2"
				:active="selectedTab == '2' || $route.query.status == 2"
			></b-tab>
			<b-tab title="|" disabled></b-tab>
			<b-tab
				title="Courses"
				tabindex="3"
				:active="selectedTab == '3' || $route.query.status == 3"
			></b-tab>
		</b-tabs>
		<div class="search-suggest-input">
			<img
				class="ss-icon-pos pointer"
				src="../../assets/newdesign/home/ssGreySearch.svg"
				alt=""
				@click="handleEnter"
			/>
			<b-form-input
				v-model="searchQuery"
				ref="searchInput"
				@input="getSearchSuggestions"
				:placeholder="`Search ${tabPlaceholder}`"
				@keydown.down.prevent="moveDown"
				@keydown.up.prevent="moveUp"
				@keydown.enter.native.prevent="handleEnter"
				autofocus
			>
			</b-form-input>

			<b-card class="ss-suggest-card">
				<template v-if="!searchQuery && searchHistory.length > 0">
					<div id="hideinlaptop" class="search-mobile-heading">
						<div class="ss-horizontal-line"></div>
						<span>YOUR RECENT SEARCHES</span>
						<div class="ss-horizontal-line"></div>
					</div>
					<h6 id="hideinmobile" class="ss-grey-txt">YOUR RECENT SEARCHES</h6>

					<div
						v-for="(search, index) in searchHistory"
						:key="index + 'index'"
						class="ss-recent-searches pointer"
						@click="handleSearchHistoryClick(search)"
						:class="{ 'active-suggestion': index === focusedIndex }"
					>
						<div class="d-flex align-items-center w-90">
							<img
								class="mr-2"
								src="../../assets/newdesign/home/ssRecentSearch.svg"
								alt=""
							/>
							<h6 class="text-truncate ss-grey-txt-3">
								{{ search.searchQuery }}
							</h6>
							<span class="ss-grey-txt-2 ml-3">
								{{
									search.type == 1
										? "in Jobs"
										: search.type == 2
										? "in Assessments"
										: "in Courses"
								}}
							</span>
						</div>
						<img
							src="../../assets/newdesign/home/ssGreyCross.svg"
							alt=""
							class="pointer"
							@click.stop="clearSearch(search.searchID)"
						/>
					</div>
				</template>
				<template v-else-if="activeTab == 3">
					<div
						v-for="(search, index1) in courseSuggestion"
						:key="index1 + 'index1'"
						class="ss-recent-searches pointer"
						@click="goToCourse(search)"
					>
						<div class="d-flex align-items-center w-90">
							<img
								class="mr-2"
								src="../../assets/newdesign/home/ssBlueSearch.svg"
								alt=""
							/>
							<h6 class="text-truncate ss-grey-txt-4">
								{{ search.title }}
							</h6>
						</div>
						<!-- <img src="../../assets/newdesign/home/ssGreyCross.svg" alt="" /> -->
					</div>
				</template>
				<template v-else>
					<div
						v-for="(search, index1) in searchSuggestions"
						:key="index1 + 'index1'"
						class="ss-recent-searches pointer"
						@click="handleSearchSuggestionsClick(search)"
						:class="{ 'active-suggestion': index1 === focusedIndex }"
					>
						<div class="d-flex align-items-center w-90">
							<img
								class="mr-2"
								src="../../assets/newdesign/home/ssBlueSearch.svg"
								alt=""
							/>
							<h6 class="text-truncate ss-grey-txt-4">
								{{
									activeTab === 1
										? search.title
										: activeTab === 2
										? search.name
										: ""
								}}
							</h6>
						</div>
						<!-- <img src="../../assets/newdesign/home/ssGreyCross.svg" alt="" /> -->
					</div>
				</template>
				<template v-if="this.activeTab === 1">
					<template v-if="jobLoader">
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED JOBS FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED JOBS FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div v-for="(i, index) in shimmerLoop" :key="index">
								<b-skeleton width="100px" height="20px"> </b-skeleton>
							</div>
						</div>
					</template>
					<template v-else>
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED JOBS FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED JOBS FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(job, index) in jobDetails"
								:key="index + 'index'"
								class="ss-tags pointer"
								@click="routeToJobDetails(job.jobID)"
							>
								<img
									src="../../assets/newdesign/home/ssSmalSearch.svg"
									alt=""
								/>{{ job.title }}
							</div>
						</div>
					</template>
				</template>
				<template v-else-if="this.activeTab === 2">
					<template v-if="assessmentShimmer">
						<!-- <div style="width: 50%">
							<b-skeleton height="20px"></b-skeleton>
						</div> -->
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED ASSESSMENTS FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED ASSESSMENTS FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div v-for="(i, index) in shimmerLoop" :key="index">
								<b-skeleton width="100px" height="20px"> </b-skeleton>
							</div>
						</div>
					</template>
					<template v-else>
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED ASSESSMENTS FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED ASSESSMENTS FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(assessment, index1) in assessments"
								:key="index1 + 'index1'"
								class="ss-tags pointer"
								@click="routeToTakeTest(assessment)"
							>
								<img
									src="../../assets/newdesign/home/ssSmalSearch.svg"
									alt=""
								/>{{ assessment.testName }}
							</div>
						</div>
					</template>
				</template>
				<template v-else-if="this.activeTab === 3">
					<template v-if="courseLoader">
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED COURSES FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED COURSES FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div v-for="(i, index) in shimmerLoop" :key="index">
								<b-skeleton width="100px" height="20px"> </b-skeleton>
							</div>
						</div>
					</template>
					<template v-else>
						<div id="hideinlaptop" class="search-mobile-heading">
							<div class="ss-horizontal-line"></div>
							<span>RECOMMENDED COURSES FOR YOU</span>
							<div class="ss-horizontal-line"></div>
						</div>
						<h6 id="hideinmobile" class="ss-grey-txt mb-2">
							RECOMMENDED COURSES FOR YOU
						</h6>
						<div class="d-flex flex-wrap gap-2">
							<div
								v-for="(course, index2) in allCourses"
								:key="index2 + 'index2'"
								class="ss-tags pointer"
								@click="goToCourse(course)"
							>
								<img
									src="../../assets/newdesign/home/ssSmalSearch.svg"
									alt=""
								/>
								{{ course.title }}
							</div>
						</div>
					</template>
				</template>
			</b-card>
		</div>
	</div>
</template>

<script>
import {
	getSearchHistoryDashboard,
	postSearchHistoryDashboard,
	deleteSearchHistoryDashboard,
	getSearchSuggestions,
	postJobSearch,
	getPublicAssessments,
	postCourse,
	getCandInfo,
	getCourseSuggestion,
} from "../../utils/apiFunctions.js";
import { config } from "@/config/index.js";

export default {
	data() {
		return {
			searchHistory: [],
			searchSuggestions: [],
			searchQuery: "",
			activeTab: 1,
			debounceTimer: null,
			jobDetails: [],
			assessments: [],
			allCourses: [],
			courseSuggestion: [],
			assessmentShimmer: false,
			jobLoader: false,
			courseLoader: false,
			shimmerLoop: 20,
			focusedIndex: -1,
		};
	},
	props: {
		selectedTab: String,
	},
	computed: {
		tabPlaceholder() {
			return this.activeTab === 1
				? " Jobs"
				: this.activeTab === 2
				? " Assessments"
				: "Courses";
		},
	},
	async created() {
		this.changeTab();
		console.log("created", this.$route.query.status);
		// this.getCourseSuggestion();
	},
	methods: {
		moveDown() {
			if (
				!this.searchQuery &&
				this.focusedIndex < this.searchHistory.length - 1
			) {
				this.focusedIndex++;
			}
		},

		moveUp() {
			if (!this.searchQuery && this.focusedIndex > 0) {
				this.focusedIndex--;
			}
		},

		handleEnter() {
			console.log(
				"SearchSuggestion Enter pressed",
				"tab:",
				this.activeTab,
				"query:",
				this.searchQuery
			);
			if (!this.searchQuery && this.focusedIndex >= 0) {
				this.handleSearchHistoryClick(this.searchHistory[this.focusedIndex]);
			} else if (this.searchQuery) {
				this.searchRoute();
			}
		},
		goToCourse(cData) {
			let link = `${config.trainingBase}/coursedetail/${
				cData.courseID || cData.referenceID
			}?component=MarketPlace&courseName=${cData.title || cData.courseName}`;
			window.open(link, "_self");
		},
		goToFilteredCoursesView() {
			let link = `${config.trainingBase}/filteredcoursesview?search=${this.searchQuery}`;
			window.open(link, "_self");
		},
		async getCourseSuggestion() {
			if (!this.searchQuery) {
				this.courseSuggestion = [];
				return;
			}

			try {
				let payload = {
					searchQuery: this.searchQuery,
				};
				const response = await getCourseSuggestion(payload);
				if (response.status == 200) {
					this.courseSuggestion = response.data.data.courseInfo.data;
				}
			} catch (error) {
				return error;
			}
		},
		handleSearchSuggestionsClick(search) {
			if (this.activeTab == 1) {
				if (search.jobID) {
					this.routeToJobDetails(search.jobID);
				} else {
					this.$router.push({
						name: "JobSearch",
						query: {
							searchQuery: search.title,
						},
					});
				}
			} else if (this.activeTab == 2) {
				if (search.courses && search.courses.length >= 1) {
					this.goToCourse(search.courses[0]);
				} else if (search.courseID) {
					this.goToCourse(search);
				} else {
					this.$router.push({
						name: "CandidateAssessmentProgress",
						query: { searchQuery: search.name },
					});
				}
			} else if (this.activeTab == 3) {
				this.goToCourse(search);
			}
		},
		async getCandidateSkills() {
			try {
				const response = await getCandInfo();
				if (response.status == 200) {
					this.email = response.data.data.email;
					this.getPublicAssessments();
				}
			} catch (error) {
				return error;
			}
		},
		handleSearchHistoryClick(search) {
			if (search.type === 1) {
				this.$router.push({
					name: "JobSearch",
					query: {
						searchQuery: search.searchQuery,
					},
				});
			} else if (search.type === 2) {
				this.$router.push({
					name: "CandidateAssessmentProgress",
					query: { searchQuery: search.searchQuery },
				});
			} else if (search.type === 3) {
				const encodedQuery = encodeURIComponent(search.searchQuery || "");
				const link = `${config.trainingBase}/filteredcoursesview?search=${encodedQuery}`;
				window.location.href = link;
			}
		},
		routeToTakeTest(assessment) {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: { searchQuery: assessment.testName },
			});
		},
		routeToJobDetails(jobID) {
			this.$router.push({
				name: "JobSearch",
				query: {
					jobID: jobID,
				},
			});
		},
		async searchRoute() {
			try {
				let payload = {
					searchQuery: this.searchQuery,
					type: this.activeTab,
				};
				const response = await postSearchHistoryDashboard(payload);
				if (response.status === 200) {
					this.getSearchSuggestions();
					if (this.activeTab == 1) {
						this.$router.push({
							name: "JobSearch",
							query: {
								searchQuery: this.searchQuery,
							},
						});
					} else if (this.activeTab == 2) {
						this.$router.push({
							name: "CandidateAssessmentProgress",
							query: { searchQuery: this.searchQuery },
						});
					} else if (this.activeTab == 3) {
						this.goToFilteredCoursesView();
					}
				}
			} catch (error) {
				console.log(error);
				// If the post fails, we still want to redirect the user
				if (this.activeTab == 1) {
					this.$router.push({
						name: "JobSearch",
						query: {
							searchQuery: this.searchQuery,
						},
					});
				} else if (this.activeTab == 2) {
					this.$router.push({
						name: "CandidateAssessmentProgress",
						query: { searchQuery: this.searchQuery },
					});
				} else if (this.activeTab == 3) {
					this.goToFilteredCoursesView();
				}
			}
		},
		async fetchCourse() {
			const strArr = {
				count: 8,
				instructorInfo: true,
				ratingSummaryInfo: true,
				wishlistInfo: true,
				sortBy: "matchPercentage",
				order: -1,
			};
			try {
				this.courseLoader = true;
				// calling Courses api
				const res = await postCourse(strArr);
				if (res.status == 200) {
					this.courseLoader = false;
					this.allCourses =
						res.data.data.data.length > 9
							? res.data.data.data.slice(0, 9)
							: res.data.data.data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getPublicAssessments() {
			this.assessmentShimmer = true;
			const res = await getPublicAssessments({
				page: 0,
				count: 10,
				email: this.email,
				searchQuery: "",
				home: true,
			});
			if (res.status == 200) {
				this.assessments = res.data.data.data;
				this.assessmentShimmer = false;
				console.log("my assess", this.assessments);
			}
		},
		async getJobs() {
			try {
				this.jobLoader = true;
				var payload = {
					count: 12,
					instructorInfo: true,
					ratingSummaryInfo: true,
					wishlistInfo: true,
					sortBy: "matchPercentage",
					order: -1,
				};
				const res = await postJobSearch(payload);
				if (res.status == 200) {
					this.jobDetails = res.data.data.data;
					this.jobLoader = false;
				}
				this.jobLoader = false;
			} catch (error) {
				console.log(error);
			}
		},

		async getSearchSuggestions() {
			if (!this.searchQuery) {
				this.searchSuggestions = [];

				return;
			}
			try {
				if (this.activeTab === 3) {
					// For courses, only use searchQuery in the payload
					const response = await getCourseSuggestion({
						searchQuery: this.searchQuery,
					});
					if (response.status == 200) {
						this.searchSuggestions =
							response.data.data.courseInfo?.data || response.data.data.data;
					}
				} else {
					// For jobs and assessments, use both searchQuery and type
					let payload = {
						searchQuery: this.searchQuery,
						type: this.activeTab,
					};
					const response = await getSearchSuggestions(payload);
					if (response.status === 200) {
						this.searchSuggestions = response.data.data.Detail;
					}
				}
			} catch (error) {
				console.log(error);
			}
		},

		async clearSearch(searchID) {
			try {
				let payload = {
					searchID: searchID,
				};
				const response = await deleteSearchHistoryDashboard(payload);
				if (response.status === 200) {
					this.getSearchHistory();
				}
			} catch (error) {
				console.log(error);
			}
		},
		async searchData() {
			try {
				let payload = {
					searchQuery: this.searchQuery,
					type: this.activeTab,
				};
				const response = await postSearchHistoryDashboard(payload);
				if (response.status === 200) {
					this.getSearchSuggestions();
				}
			} catch (error) {
				console.log(error);
			}
		},
		async changeTab(tabIndex) {
			console.log("change", tabIndex);
			if (tabIndex === 0) {
				this.activeTab = 1;
				this.getJobs();
			} else if (tabIndex === 2) {
				this.activeTab = 2;
				await this.getCandidateSkills();
			} else if (tabIndex === 4) {
				this.activeTab = 3;
				this.fetchCourse();
			}
			this.searchSuggestions = [];
			this.searchQuery = "";
			this.getSearchHistory();
		},
		async getSearchHistory() {
			try {
				let payload = {
					count: 8,
				};
				const response = await getSearchHistoryDashboard(payload);
				if (response.status == 200) {
					this.searchHistory = response.data.data.data;
				}
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>

<style>
.ss-grey-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	letter-spacing: 0.08em;
	color: #646464;
}

.ss-grey-txt-2 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-M);
	color: #7a7a7a;
}

.ss-grey-txt-3 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--cv-lightGray);
	max-width: 75%;
}

.ss-grey-txt-4 {
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--cv-lightGray);
	max-width: 85%;
}

h6 {
	margin-bottom: 0;
}

.search-suggest {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 30px;
}

.search-suggest .card-header:first-child {
	border-radius: 25px;
	box-shadow: 0px 4px 4px 0px #00000040;
	background-color: #f6fafd;
	padding: 4px;
	width: 402px;
}

.search-suggest .card-header-pills {
	margin: 0;
}

.search-suggest .nav {
	width: 100%;
}

.search-suggest .nav-pills .nav-link.active,
.search-suggest .nav-pills .show > .nav-link {
	background-color: var(--bg-proTheme);
	font-family: "Lato", sans-serif;
	font-size: var(--size-18);
	font-weight: var(--weight-LM);
	color: var(--bg-white);
	border-radius: 25px;
	padding: 3px 20px;
}

.search-suggest .nav-pills .nav-link {
	background: none;
	font-family: "Lato", sans-serif;
	font-size: var(--size-18);
	font-weight: var(--weight-LM);
	color: #7a7a7a;
	padding: 3px 20px;
}

.search-suggest .nav-link.disabled {
	padding: 2px 15px;
}

.search-suggest .tab-content {
	height: 0px;
}

.search-suggest-input {
	width: 700px;
	background: linear-gradient(
			270deg,
			rgba(32, 99, 155, 0.026) 0%,
			rgba(32, 99, 155, 0.2) 100%
		),
		linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15));
	padding: 4px;
	border-radius: 4px;
	position: relative;
	margin-top: 15px;
}

.search-suggest-input .form-control {
	height: 30px;
	padding: 5px 10px 7px 40px;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	color: var(--cv-lightGray);
}

.search-suggest-input .form-control:focus {
	box-shadow: none;
}

.ss-icon-pos {
	position: absolute;
	left: 20px;
	top: 12px;
}

.ss-suggest-card {
	width: 700px;
	box-shadow: 0px 8px 8px 0px #1018280a;
	position: absolute;
	left: 0px;
	top: 41px;
	background-color: #f9f9f9;
	border-radius: 8px;
}

.ss-suggest-card .card-body {
	padding: 10px;
	min-height: auto;
	max-height: calc(100vh - 420px);
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.ss-recent-searches {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 3px 0;
}

.ss-tags {
	background-color: #d8dce4;
	border-radius: 4px;
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--bg-proTheme);
	gap: 6px;
	display: flex;
	align-items: center;
	padding: 4px 10px;
}

/* * {
	transition: all 0.3s linear;
} */

@media (max-width: 1028px) {
	.search-suggest {
		margin-top: 10px;
	}

	.search-suggest .card-header:first-child {
		padding: 4px;
		width: unset;
		box-shadow: none;
	}

	.search-suggest .nav-pills .nav-link.active,
	.search-suggest .nav-pills .show > .nav-link {
		font-size: var(--size-14);
		padding: 3px 20px;
	}

	.search-suggest .nav-pills .nav-link {
		font-size: var(--size-14);
		padding: 3px 20px;
	}

	.search-suggest .nav-link.disabled {
		padding: 2px 2px;
	}

	.search-suggest-input {
		width: 100%;
		background: none;
		padding: unset;
		border-radius: unset;
		position: relative;
		margin-top: 15px;
	}

	.search-suggest-input .form-control {
		height: 40px;
		padding: 5px 10px 7px 40px;
		font-family: "Montserrat", sans-serif;
		font-size: var(--size-14);
		font-weight: var(--weight-LM);
		color: var(--cv-lightGray);
		border-radius: 8px;
		border: none;
	}

	.search-suggest-input .form-control:focus {
		box-shadow: none;
	}

	.ss-icon-pos {
		position: absolute;
		left: 17px;
		top: 13px;
	}

	.ss-suggest-card {
		width: 100%;
		background-color: #e9ecef;
		border: none;
		box-shadow: none;
		position: unset;
	}

	.ss-suggest-card .card-body {
		padding: unset;
		padding-top: 20px;
		height: calc(100vh - 210px);
		min-height: unset;
		max-height: unset;
		overflow: auto;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.search-suggest .tabs {
		width: 100%;
	}

	.search-suggest .nav {
		width: 100%;
		justify-content: space-between;
	}

	.search-mobile-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: "Montserrat", sans-serif;
		font-size: var(--size-13);
		font-weight: var(--weight-LM);
		letter-spacing: 0.08em;
		color: #646464;
		gap: 15px;
		margin: 10px 0;
	}

	.ss-grey-txt-3 {
		font-family: "Lato", sans-serif;
		font-size: var(--size-13);
		font-weight: var(--weight-M);
		color: var(--bg-proTheme);
		max-width: 58%;
	}

	.ss-grey-txt-4 {
		font-family: "Lato", sans-serif;
		font-size: var(--size-13);
		font-weight: var(--weight-M);
		color: var(--bg-proTheme);
		max-width: 85%;
	}

	.ss-horizontal-line {
		height: 1px;
		flex: 1;
		background-color: #646464;
	}

	#hideinmobile {
		display: none !important;
	}
}
.active-suggestion {
	background-color: #e5f2ff;
	border-radius: 4px;
}
</style>
<style scoped>
@media (min-width: 1029px) {
	#hideinlaptop {
		display: none !important;
	}
}
</style>
